<sf-smartquote-nav></sf-smartquote-nav>

@if (statistics2$ | async; as stats) {
    <sf-card cardTitle="SmartQuotes for {{ this.selectedYear() === -1 ? 'all time' : this.selectedYear() }}">
        <ng-container *sfCardHeader>
            <div class="d-flex justify-content-end">
                <div ngbDropdown class="d-inline-block">
                    <button sfButton type="button" size="sm" color="primary" id="yearDD" ngbDropdownToggle>
                        Showing {{ selectedYear() === -1 ? 'All' : selectedYear() }}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="yearDD">
                        @for (year of yearOptions; track year) {
                            <button ngbDropdownItem (click)="onChangeYear(year)">{{ year }}</button>
                        }
                        <button ngbDropdownItem (click)="onChangeYear(-1)">All</button>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="row g-2 mb-3">
            @for (item of base(); track item) {
                <div class="col-md-3">
                    <sf-simple-stat-box [heading]="item.name" [count]="item.count"></sf-simple-stat-box>
                    <!-- <div class="d-flex small">
                        <span> {{ item.name }} for {{ item.year }}: </span>
                        <span class="ms-auto fw-bold">{{ item.count }}</span>
                    </div> -->
                </div>
            }
        </div>
        <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [xaxis]="chartOptions.xaxis!"
            [title]="chartOptions.title!"></apx-chart>
    </sf-card>
}
